import React, { useEffect } from 'react';
import AuditScanner from './AuditScanner/AuditScanner';
import { motion } from 'framer-motion';
import SEOHead from './SEOHead';

export const ReadinessScannerPage: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="pt-28 bg-gray-50 min-h-screen">
            <SEOHead />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <div className="bg-gradient-to-b from-blue-900 via-blue-800 to-gray-900 py-20 text-center text-white relative overflow-hidden">
                    {/* Abstract background elements */}
                    <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none">
                        <div className="absolute top-[-10%] left-[-10%] w-1/2 h-full bg-blue-400 blur-[120px] rounded-full" />
                        <div className="absolute bottom-[-10%] right-[-10%] w-1/2 h-full bg-purple-500 blur-[120px] rounded-full" />
                    </div>

                    <div className="container mx-auto px-4 relative z-10">
                        <motion.h1
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.2 }}
                            className="text-4xl md:text-7xl font-bold mb-6 font-display tracking-tight"
                        >
                            AI Technical Audit
                        </motion.h1>
                        <motion.p
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.3 }}
                            className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed"
                        >
                            Analyze your digital infrastructure against the performance and security standards of 2026.
                        </motion.p>
                    </div>
                </div>
                <AuditScanner />
            </motion.div>
        </div>
    );
};

export default ReadinessScannerPage;
